"use client";

import dynamic from "next/dynamic";

// Disable prerendering for the App component for now
const Page = dynamic(() => import("components/App"), { ssr: false });

export default Page;
